/* eslint-disable max-len */

const buttonset = {
    field_type: 'buttonset',
    buttons: [
        {
            type: 'submit',
            label: 'Save',
            loading_label: 'Saving…',
            className: 'button fullwidth dark primary xlarge',
        },
    ],
}


// these are spotlights that are no longer offered but are still supported on the page until the user changes them
const grandfathered_list = [
    {
        id: 'signup_for',
        is_premium: true,
        label: 'Sign up for my…',
        glyph: 'edit',
        mechanism: 'link',
        tweet_text(user) {
            return `Sign up for my ${user.get('spotlight.text')} from my @aboutdotme page! 📝➡️`
        },
        fields: [
            {
                field_type: 'input',
                key: 'text',
                element: {
                    label: 'Enter what it is you’re hosting.',
                    placeholder: 'e.g. event, online course, workshop',
                },
            },
            {
                field_type: 'input',
                key: 'url',
                element: {
                    label: 'Enter a link to your signup page.',
                    placeholder: 'example.com',
                },
            },
            buttonset,
        ],
    },
    {
        id: 'book_consultation_free',
        is_premium: false,
        label: 'Book a consultation',
        mechanism: 'contact',
        glyph: 'hireme',
        tweet_text(user) {
            return 'Book a consultation with me from my @aboutdotme page! ☎️📆'
        },
        fields: [
            {
                field_type: 'note',
                calculated_values: {
                    html() {
                        return `Messages will be sent to <span class="text ellipsis">${this.user.get('email_address')}</span>. Your email address will not be displayed.`
                    },
                },
            },
            buttonset,
        ],
    },
    {
        id: 'hire_me_free',
        is_premium: false,
        label: 'Hire me',
        glyph: 'hireme',
        mechanism: 'contact',
        tweet_text(user) {
            return 'Hire me from my @aboutdotme page! 💼👍'
        },
        fields: [
            {
                field_type: 'note',
                calculated_values: {
                    html() {
                        return `Messages will be sent to <span class="text ellipsis">${this.user.get('email_address')}</span>. Your email address will not be displayed.`
                    },
                },
            },
            buttonset,
        ],
    },
    {
        id: 'date_me',
        is_premium: false,
        label: 'Date me',
        glyph: 'date',
        mechanism: 'link',
        tweet_text(user) {
            return 'Date me from my @aboutdotme page! 😉💕'
        },
        fields: [
            {
                field_type: 'input',
                key: 'url',
                element: {
                    label: 'Enter a link to your dating profile.',
                    placeholder: 'example.com',
                },
            },
            buttonset,
        ],
    },
]

// mark all as grandfathered
grandfathered_list.forEach(spotlight => {
    spotlight.grandfathered = true
    spotlight.group = 'grandfathered'
})

module.exports = grandfathered_list
